import React, { Fragment } from 'react';
import { NavLink } from "react-router-dom";

import './Layout.css';
import "../../styles/uikit.css";

const layout = (props) => (
  <Fragment>
    <header className="m-header js-header">
      <div className="uk-container uk-container-large">
        <div className="mn-header__top">
          <h1 className="mn-header__logo">
            {/* <a className="with-new-logo" href="/"></a> */}
            <NavLink to="/">{/* <Logo /> */}</NavLink>
          </h1>
          <h2 className="mn-header__tag">پنل مدیریت وبسایت</h2>
        </div>
      </div>
    </header>

    <header className="main-header">{props.header}</header>
    {props.mobileNav}
    {props.children}
  </Fragment>
);

export default layout;
